export const apis = {
    baseUrl: "https://api.ccsuniversity.ac.in/",
    
    getWeather:'weather/',

    getAllDepartment:'department/',

    getAllFaculty:'faculty/',

    getAllOMR:'omr/',

    getAllSyllabus:'syllabus/course/',

    getAllExamRelatedInfo:'news/category/56423ba7-e779-11ee-b639-0242ac120005',

    getAllExamSchedule:'news/category/3408789e-e779-11ee-b639-0242ac120005',

    getAllRevisedExamSchedule:'news/category/3d939868-e779-11ee-b639-0242ac120005',

    getAllCodeBooksandDownloads:'news/category/c5d7bc33-e778-11ee-b639-0242ac120005',

    getAllCareerInfo:'news/category/2d4ba3ba-e779-11ee-b639-0242ac120005',

    getAllTendersInfo:'news/category/988b9e33-e778-11ee-b639-0242ac120005',

    getAllSportsCalendar:'news/category/5b84d307-e779-11ee-b639-0242ac120005',

    getHomeData:'home/',

    getAllSearchNewsData:'news/search',

    getAllSearchNewsByCategoryData:'news/category/'

}